import { useEffect } from 'react';

// Stores
import stores from 'bootstrap/store';

// Constants
import { API_BASE } from 'constants/index';

export default function useAuthorizationCode() {
  const urlParams = new URLSearchParams(window.location.search);
  const authorizationCode = urlParams.get('code');
  useEffect(() => {
    if (!authorizationCode) return;

    (async () => {
      const body = {
        authorizationCode,
      };
      const response = await fetch(`${API_BASE}/saml/exchange`, {
        method: 'PUT',
        body: JSON.stringify(body),
        headers: { 'Content-Type': 'application/json' },
      });
      const data = await response.json();
      console.log(data);
      if (!data.accessToken) return console.error('No access token returned');

      // This is watched, and in turn updates the auth token in the global auth store,
      // which in turn updates the active token in local storage.
      stores.global.users.setValue('activeToken', data.accessToken);
      setTimeout(() => {
        // Strip the code from the URL.
        window.history.replaceState({}, '', window.location.pathname);

        window.location.reload(); // Should now direct user to appropriate page.
      }, 100);
    })();

  }, [authorizationCode]);
}
